import "./App.css"
import React from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"

import HomePage from "./pages/HomePage"
import InfoPage from "./pages/InfoPage"
import SignInPage from "./pages/SingInPage"
import NoPage from "./pages/NoPage"
import TournamentsPage from "./pages/TournamentsPage"
import TrainingsPage from "./pages/TrainingsPage"
import ContactPage from "./pages/ContactPage"
import ResponsiveAppBar from "./components/ResponsiveAppBar"
import Footer from "./components/Footer"
import FAQComponent from "./components/InfoComponents/FAQComponent/FAQComponent"
import WorldMapTabComponent from "./components/InfoComponents/WorldMapComponent/WorldMapTabComponent"
import EntrenoTabComponent from "./components/TrainingsComponents/EntrenoTabComponent"
import NeedsTabComponent from "./components/TrainingsComponents/NeedsTabComponent"
import NewGameTabComponent from "./components/TrainingsComponents/NewGameTabComponent"
import EquipmentTabComponent from "./components/InfoComponents/EquipmentTabComponent"
import HowToTabComponent from "./components/InfoComponents/HowToTabComponent"
import SeleccionTabComponent from "./components/InfoComponents/SeleccionTabComponent"
import TallerTabComponent from "./components/InfoComponents/TallerTabComponent"
import EscribenosTabComponent from "./components/ContactsComponents/EscribenosTabComponent"
import OtrosClubsTabComponent from "./components/ContactsComponents/OtrosClubsTabComponent"
import JugadoresTabComponent from "./components/ContactsComponents/JugadoresTabComponent"

class App extends React.Component {
	componentDidMount() {}

	render() {
		return (
			<BrowserRouter>
				<ResponsiveAppBar title="UWH Madrid Club" />
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route path="inicio" element={<HomePage />} />
					<Route path="entrenamientos" element={<TrainingsPage />}>
						<Route index element={<EntrenoTabComponent />} />
						<Route path="entrenos" element={<EntrenoTabComponent />} />
						<Route path="needs" element={<NeedsTabComponent />} />
						<Route path="new_game" element={<NewGameTabComponent />} />
					</Route>
					<Route path="torneos" element={<TournamentsPage />} />
					<Route path="contacta" element={<ContactPage />}>
						<Route index element={<EscribenosTabComponent />} />
						<Route path="escribenos" element={<EscribenosTabComponent />} />
						<Route path="otrosclubs" element={<OtrosClubsTabComponent />} />
						<Route path="jugadores" element={<JugadoresTabComponent />} />
					</Route>
					<Route path="info" element={<InfoPage />}>
						<Route index element={<FAQComponent />} />
						<Route path="conceptos" element={<FAQComponent />} />
						<Route path="equipamiento" element={<EquipmentTabComponent />} />
						<Route path="howto" element={<HowToTabComponent />} />
						<Route path="seleccion" element={<SeleccionTabComponent />} />
						<Route path="taller" element={<TallerTabComponent />} />
						<Route path="world" element={<WorldMapTabComponent />} />
					</Route>

					<Route path="signin" element={<SignInPage />} />

					<Route path="*" element={<NoPage />} />
				</Routes>
				<Footer />
			</BrowserRouter>
		)
	}
}

export default App
